<template>
  <div class="Membership-content">
    <!-- 标题现在包含在内容中，不再单独显示 -->
    <div class="membership-container">
      <div class="content-section" ref="htmlShow">
        <div class="rich-text-content" v-html="processedContent"></div>
      </div>
      <div class="qr-section">
        <ShareQrVip
          :show-applet="true"
          :show-home-stay="true"
          :show-qr-code="null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ShareQrVip from "@/views/components/shareQrVip";

export default {
  components: {
    ShareQrVip,
  },
  data() {
    return {
      isMobileOrTablet: false,
      resizeTimer: null,
      membershipData: {
        // 新的数据结构，适配接口返回的中英文内容
        contentCn: "",
        contentEn: "",
      },
    };
  },
  computed: {
    // 根据当前语言状态返回对应的内容
    processedContent() {
      // 使用Vuex的isEn状态来判断当前语言
      const currentContent = this.$store.state.isEn
        ? this.membershipData.contentEn
        : this.membershipData.contentCn;

      // 如果当前语言的内容为空，返回另一个语言的内容作为备选
      return currentContent || this.membershipData.contentCn;
    },
  },
  mounted() {
    // 初始化屏幕尺寸检测
    this.checkScreenSize();

    // 应用响应式字体大小
    this.updateFontSizeClass();
    this.init();

    // 添加resize事件监听器
    window.addEventListener("resize", this.handleResize);

    // 监听语言变化
    this.$store.watch(
      () => this.$store.state.isEn,
      () => {
        // 语言切换后更新字体大小
        this.$nextTick(() => {
          this.updateFontSizeClass();
        });
      }
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    init() {
      this.$api.get("/summary/joinUsDetail", {}, (r) => {
        const { data, code } = r;
        if (code == 0) {
          // 更新数据结构以匹配接口返回
          this.membershipData = {
            contentCn: data.contentCn || "",
            contentEn: data.contentEn || "",
          };

          // DOM 更新后调整字体大小
          this.$nextTick(() => {
            this.updateFontSizeClass();
          });
        }
      });
    },
    // 防抖处理resize事件
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.timer = setTimeout(() => {
        this.checkScreenSize();
        this.updateFontSizeClass();
      }, 100);
    },

    // 检查屏幕尺寸
    checkScreenSize() {
      this.isMobileOrTablet = window.innerWidth <= 968;
    },

    // 更新富文本内容的字体大小
    updateFontSizeClass() {
      const screenWidth = window.innerWidth;
      const htmlShowElement = this.$refs.htmlShow;

      if (!htmlShowElement) return;

      // 清除现有样式
      const richTextElement =
        htmlShowElement.querySelector(".rich-text-content");
      if (!richTextElement) return;

      // 清除之前可能添加的内联样式
      const elements = richTextElement.querySelectorAll(
        "*[style*='font-size'], *[style*='line-height'], *[style*='margin'], *[style*='padding']"
      );
      elements.forEach((el) => {
        // 仅移除特定的样式属性，保留原始HTML中的样式
        if (el.style.fontSize) el.style.fontSize = "";
        if (el.style.lineHeight) el.style.lineHeight = "";
        if (el.style.margin) el.style.margin = "";
        if (el.style.padding) el.style.padding = "";
      });

      // 根据屏幕宽度设置字体大小
      if (screenWidth <= 960) {
        // 小屏幕 - 设置基础字体大小
        const paragraphs = richTextElement.querySelectorAll("p");
        paragraphs.forEach((p) => {
          p.style.fontSize = "14px";
          p.style.lineHeight = "24px";
          p.style.marginBottom = "12px";
        });

        const headings = richTextElement.querySelectorAll(
          "h1, h2, h3, h4, h5, h6"
        );
        headings.forEach((h) => {
          switch (h.tagName) {
            case "H1":
              h.style.fontSize = "24px";
              break;
            case "H2":
              h.style.fontSize = "20px";
              break;
            case "H3":
              h.style.fontSize = "18px";
              break;
            case "H4":
              h.style.fontSize = "16px";
              break;
            case "H5":
              h.style.fontSize = "14px";
              break;
            case "H6":
              h.style.fontSize = "12px";
              break;
          }
          h.style.margin = "16px 0";
          h.style.fontWeight = "bold";
        });

        const lists = richTextElement.querySelectorAll("ul, ol");
        lists.forEach((list) => {
          list.style.fontSize = "14px";
          list.style.lineHeight = "24px";
          list.style.margin = "12px 0";
          list.style.paddingLeft = "20px";
        });

        const listItems = richTextElement.querySelectorAll("li");
        listItems.forEach((li) => {
          li.style.fontSize = "14px";
          li.style.lineHeight = "22px";
          li.style.margin = "6px 0";
        });

        const images = richTextElement.querySelectorAll("img");
        images.forEach((img) => {
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          img.style.marginBottom = "0px";
        });

        // 为分割线设置小屏幕的间距
        const dividers = richTextElement.querySelectorAll('div[style*="margin-top: 50px"][style*="margin-bottom: 50px"]');
        dividers.forEach((divider) => {
          divider.style.marginTop = "20px";
          divider.style.marginBottom = "20px";
        });
      } else if (screenWidth <= 1440) {
        // 中等屏幕 - 设置基础字体大小
        const paragraphs = richTextElement.querySelectorAll("p");
        paragraphs.forEach((p) => {
          p.style.fontSize = "16px";
          p.style.lineHeight = "28px";
          p.style.marginBottom = "14px";
        });

        const headings = richTextElement.querySelectorAll(
          "h1, h2, h3, h4, h5, h6"
        );
        headings.forEach((h) => {
          switch (h.tagName) {
            case "H1":
              h.style.fontSize = "28px";
              break;
            case "H2":
              h.style.fontSize = "24px";
              break;
            case "H3":
              h.style.fontSize = "20px";
              break;
            case "H4":
              h.style.fontSize = "18px";
              break;
            case "H5":
              h.style.fontSize = "16px";
              break;
            case "H6":
              h.style.fontSize = "14px";
              break;
          }
          h.style.margin = "16px 0";
          h.style.fontWeight = "bold";
        });

        const lists = richTextElement.querySelectorAll("ul, ol");
        lists.forEach((list) => {
          list.style.fontSize = "16px";
          list.style.lineHeight = "26px";
          list.style.margin = "14px 0";
          list.style.paddingLeft = "20px";
        });

        const listItems = richTextElement.querySelectorAll("li");
        listItems.forEach((li) => {
          li.style.fontSize = "16px";
          li.style.lineHeight = "24px";
          li.style.margin = "8px 0";
        });

        const images = richTextElement.querySelectorAll("img");
        images.forEach((img) => {
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          img.style.marginBottom = "18px";
        });

        // 为分割线设置中等屏幕的间距
        const dividers = richTextElement.querySelectorAll('div[style*="margin-top: 50px"][style*="margin-bottom: 50px"]');
        dividers.forEach((divider) => {
          divider.style.marginTop = "30px";
          divider.style.marginBottom = "30px";
        });
      } else {
        // 大屏幕 - 设置基础字体大小
        const paragraphs = richTextElement.querySelectorAll("p");
        paragraphs.forEach((p) => {
          p.style.fontSize = "18px";
          p.style.lineHeight = "32px";
          p.style.marginBottom = "16px";
        });

        const headings = richTextElement.querySelectorAll(
          "h1, h2, h3, h4, h5, h6"
        );
        headings.forEach((h) => {
          switch (h.tagName) {
            case "H1":
              h.style.fontSize = "32px";
              break;
            case "H2":
              h.style.fontSize = "28px";
              break;
            case "H3":
              h.style.fontSize = "24px";
              break;
            case "H4":
              h.style.fontSize = "20px";
              break;
            case "H5":
              h.style.fontSize = "18px";
              break;
            case "H6":
              h.style.fontSize = "16px";
              break;
          }
          h.style.margin = "16px 0";
          h.style.fontWeight = "bold";
        });

        const lists = richTextElement.querySelectorAll("ul, ol");
        lists.forEach((list) => {
          list.style.fontSize = "18px";
          list.style.lineHeight = "28px";
          list.style.margin = "16px 0";
          list.style.paddingLeft = "20px";
        });

        const listItems = richTextElement.querySelectorAll("li");
        listItems.forEach((li) => {
          li.style.fontSize = "18px";
          li.style.lineHeight = "26px";
          li.style.margin = "10px 0";
        });

        const images = richTextElement.querySelectorAll("img");
        images.forEach((img) => {
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          img.style.marginBottom = "26px";
        });

        // 为分割线设置大屏幕的间距，保持原始值
        const dividers = richTextElement.querySelectorAll('div[style*="margin-top: 50px"][style*="margin-bottom: 50px"]');
        dividers.forEach((divider) => {
          divider.style.marginTop = "50px";
          divider.style.marginBottom = "50px";
        });
      }
    },
  },
};
</script>

<style scoped>
.Membership-content {
  padding: 20px;
  max-width: 1440px;
  margin: 100px auto 30px;
  text-align: left;
}

h1 {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-bottom: 30px;
}

.membership-container {
  display: flex;
  gap: 40px;
  max-width: 1440px;
}

.content-section {
  flex: 1;
  min-width: 0; /* 防止flex item溢出 */
}

.rich-text-content {
  line-height: 1.6;
}

.rich-text-content h2 {
  font-size: 22px;
  color: #333;
  margin: 24px 0;
  font-weight: bold;
}

.rich-text-content p {
  font-size: 16px;
  color: #666;
  line-height: 28px;
  margin: 16px 0;
}

.rich-text-content ul,
.rich-text-content ol {
  padding-left: 20px;
  margin: 16px 0;
}

.rich-text-content li {
  font-size: 16px;
  color: #666;
  line-height: 28px;
  margin: 8px 0;
}

.qr-section {
  margin-top: 117px;
  width: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* 响应式设计 */

@media (max-width: 1440px) {
  .Membership-content {
    width: 90%;
    padding: 15px;
  }

  .membership-container {
    gap: 30px;
  }
  .qr-section {
    margin-top: 111px;
  }

  .rich-text-content p,
  .rich-text-content li {
    font-size: 16px;
    line-height: 26px;
  }

  h1 {
    font-size: 24px;
  }

  .rich-text-content h2 {
    font-size: 20px;
  }
  .qr-section {
  max-width: 25%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
}

@media (max-width: 960px) {
  .Membership-content {
    padding: 30px;
  }

  .membership-container {
    gap: 20px;
  }

  .rich-text-content p,
  .rich-text-content li {
    font-size: 14px;
    line-height: 24px;
  }

  h1 {
    font-size: 22px;
  }

  .rich-text-content h2 {
    font-size: 18px;
  }

  .qr-section {
    margin-top: 105px;
    max-width: 100%;
    display: block;
  }
}
@media (max-width: 768px) {
  .Membership-content {
    width: 100%;
    margin: 60px auto 20px;
  }
  .membership-container {
    flex-direction: column;
  }

  .qr-section {
    max-width: 100%;
    margin-top: 30px;
    justify-content: center;
  }
}
</style>